import { Injectable } from '@angular/core';
import { AccountService } from './account.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthGuardAdminService {

  constructor(public accountService: AccountService,
    public router: Router) { }

  /**
  * Return true if logged user has role admin, otherwise
  * it redirects to dashboard
  */
  canActivate(): boolean {
    if (!this.accountService.isAdmin()) {
      this.router.navigate(['dashboard']);
      return false;
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard-admin.service.ts